module.exports = __webpack_public_path__ + "img/logo-1.03d38413.png";